"use strict";

/*
 * Aufklappmenues - ohne Bootstrap-JavaScript und ohne Popper.
 *
 * Am 2026-09-01 eingefuehrt. Bedient data-bs-toggle="dropdown" wie vorher.
 *
 * Wichtig: die Position steckt im CSS hinter einem Attribut, das Bootstrap erst
 * zur Laufzeit setzt -
 *
 *     .dropdown-menu[data-bs-popper]{top:100%;left:0;margin-top:.125rem}
 *
 * Ohne data-bs-popper hat das Menue zwar position:absolute, aber kein top und
 * kein left, und landet an der falschen Stelle. Deshalb setzen wir es hier
 * selbst auf "static" - genau den Wert, den Bootstrap in einer Navigationsleiste
 * verwendet. Popper (77 KiB) braucht es dafuer nicht: beide Menues dieser Seite
 * haengen in der Navigationsleiste und klappen gerade nach unten auf.
 */

function menueVon(knopf) {
    var eltern = knopf.parentElement;
    if (!eltern) {
        return null;
    }

    return eltern.querySelector(".dropdown-menu");
}

function zu(knopf, menue) {
    knopf.classList.remove("show");
    knopf.setAttribute("aria-expanded", "false");
    if (menue) {
        menue.classList.remove("show");
        menue.removeAttribute("data-bs-popper");
    }
}

function alleZu(ausser) {
    document.querySelectorAll('[data-bs-toggle="dropdown"].show').forEach(function (knopf) {
        if (knopf !== ausser) {
            zu(knopf, menueVon(knopf));
        }
    });
}

document.addEventListener("click", function (e) {
    var knopf = e.target.closest('[data-bs-toggle="dropdown"]');

    if (!knopf) {
        // Klick irgendwo sonst schliesst alles.
        alleZu(null);
        return;
    }

    e.preventDefault();
    var menue = menueVon(knopf);
    var offen = knopf.classList.contains("show");

    alleZu(knopf);

    if (offen) {
        zu(knopf, menue);
        return;
    }

    knopf.classList.add("show");
    knopf.setAttribute("aria-expanded", "true");
    if (menue) {
        menue.setAttribute("data-bs-popper", "static");
        menue.classList.add("show");
    }
});

document.addEventListener("keydown", function (e) {
    if (e.key === "Escape") {
        alleZu(null);
    }
});
